import LegalPageWrapper from '@/routes/legal+/LegalPageWrapper';

const PrivacyPolicyPage = () => {
  return (
    <LegalPageWrapper title="Privacy Policy">
      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">INTRODUCTION</h2>
        <p className="text-base">
          This Application and/or Website (“Platform”) and its contents are
          owned by Future City Now (&quot;we,&quot; &quot;us,&quot; or
          &quot;our&quot;), along with third-party vendors contracted by us to
          run and maintain the functionality of our Platform. We are committed
          to protecting the privacy of those who use our Platform.
        </p>
        <p className="text-base">
          This Privacy Policy describes the information we collect, how we use
          it, and your options as you interact with the Platform. By using this
          Platform, you agree to this Privacy Policy. Please read the following
          carefully before using the Platform.
        </p>
        <p className="text-base">
          Please note that this Privacy Policy does not govern the collection
          and use of information by companies that we do not control, nor by
          individuals not employed or managed by us. If you visit another
          website outside of our Platform (whether recommended, referenced, or
          linked), we strongly encourage you to review that website’s privacy
          policy before providing that website your information. This Privacy
          Policy applies only to our Platform.
        </p>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">YOUR CONSENT</h2>
        <p className="text-base">
          By using our Platform, you consent to the collection, use, and sharing
          of information as described in this Privacy Policy. By providing us
          with an email address when you subscribe, request to be contacted, or
          request a free 30-minute consult, you agree that we may use your email
          address to communicate with you about our services and select messages
          from our partners or affiliates.
        </p>
        <p className="text-base">
          NOTE: Opt-out options are discussed in the section entitled
          “Third-Party Vendors and Ways to Opt Out”.
        </p>

        <h2 className="text-lg font-bold my-4">INFORMATION WE COLLECT</h2>
        <p className="text-base">
          You may use our Platform without providing any personal information.
          When you reply to any of our communications with a request, we may
          need to collect additional information. For example, you may be asked
          to provide personally identifiable information (PII), such as first
          and last name, email address, phone number, and the name of your
          organization.
        </p>
        <p className="text-base">
          If you submit any personal information relating to other people, you
          represent that you have the authority to do so and permit us to use
          the information in accordance with this Privacy Policy. By submitting
          personal information, you grant us the right to transmit, monitor,
          retrieve, store, and use your information in connection with the
          operation of the Platform.
        </p>
        <p className="text-base">
          When you submit personal information, we may also collect certain
          information by automated means, such as cookies and web beacons. A
          “cookie” is a text file that websites send to a visitor’s computer or
          other Internet-connected device to uniquely identify the visitor’s
          browser or to store information or settings in the browser. A “web
          beacon,” also known as an Internet tag, pixel tag, or clear GIF, is
          used to transmit information about actions of the user opening the
          page or email containing the beacon back to a web server. Certain
          features of the Services may use local shared objects (or Flash
          cookies) to collect and store information about your preferences and
          how you interact with the Services. We may also use third-party
          analytics tools (e.g., Google Analytics) that separately stores and
          collects information about use of the Services and user traffic. The
          information we may collect by automated means may include, without
          limitation:
        </p>
        <br />
      </div>
      <div className="space-y-6">
        <ul className="ml-6 list-disc space-y-2">
          <li>
            Information about the devices you use to access the Services (such
            as your computer’s domain name, the IP address and the type of the
            device, operating system, and web browser).
          </li>
          <li>
            Dates, times, and duration of use of the Services (including whether
            you are a repeat or first-time visitor).
          </li>
          <li>
            Information on actions taken when using the Services (such as page
            views and navigation patterns).
          </li>
        </ul>
        <p className="text-base">
          This information helps us to improve and personalize our Services,
          focus our marketing efforts more precisely, and helps us identify and
          authenticate users.
        </p>
        <p className="text-base">
          Additionally, you may also opt to create a “gener.us” account. This is
          a secure application available to you for donations. All credit card
          information is processed externally by an approved third-party credit
          card processor. We will not store, process, and/or transmit your card
          information; however, PII may be stored within our Platform. Before
          creating a “gener.us” account, please review the “gener.us” Terms of
          Service.
        </p>

        <h2 className="text-lg font-bold my-4">HOW WE USE THIS INFORMATION</h2>
        <p className="text-base">
          You have the right to choose whether to disclose PII to us. For the
          purposes of this Privacy Policy, PII is information that can be used
          to identify you such as:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            your first and last name, company affiliation, email address, phone
            number, billing address, and shipping address
          </li>
          <li>your user ID and password</li>
          <li>credit card information</li>
          <li>any account-preference information you provide</li>
          <li>
            your computer&apos;s domain name and IP address, indicating where
            your computer is located on the Internet
          </li>
          <li>
            session data for your login session so that our computer can
            &apos;talk&apos; to yours while you are logged in
          </li>
        </ul>
      </div>
      <div className="space-y-6">
        <br />
        <p className="text-base">The PII you provide us may be used to:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>fulfill online requests</li>
          <li>process credit card information</li>
          <li>
            respond to customer service inquiries, questions, and requests to
            improve customer service,
          </li>
          <li>help us provide or improve the services we offer</li>
          <li>
            personalize your experience and inform you about the
            treatments/services in which you have indicated an interest
          </li>
          <li>
            tailor digital advertisements on third-party websites based on your
            interactions on our Platform
          </li>
          <li>
            improve our Platform offerings and send you information and updates
          </li>
          <li>
            provide aggregated statistical information, in a way that your
            identity cannot be determined
          </li>
          <li>
            comply with a legal request, such as a subpoena or search warrant
          </li>
          <li>
            respond to an external auditor that has agreed to keep the
            information confidential
          </li>
          <li>enforce applicable Terms of Service</li>
          <li>
            protect the rights, safety, or property of our Platform, its users,
            or others, such as during the exchange of information with other
            organizations for the purposes of fraud protection and/or risk
            reduction
          </li>
          <li>administer a promotion, survey, or other site feature</li>
          <li>communicate changes to our Privacy Policy</li>
        </ul>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">
          THIRD-PARTY VENDORS AND WAYS TO OPT-OUT
        </h2>
        <p className="text-base">
          By providing your PII to us, either directly or through a reseller or
          other business partner, we will:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            not sell or rent it to a third-party without your permission. Unless
            you opt-out by sending us an email at{' '}
            <a
              href="mailto:incidents@futurecitynow.com"
              className="underline decoration-[#7F7F79] underline-offset-4"
            >
              incidents@futurecitynow.com
            </a>
            , we may use your contact information to provide you with
            information we believe you need to know or may find useful, such as
            news about our services and products and modifications to the Terms
            of Service
          </li>
          <li>
            take commercially reasonable precautions to protect the information
            from loss, misuse, unauthorized access, disclosure, alteration, and
            destruction
          </li>
        </ul>
        <p className="text-base">
          In the course of our business, we may share information with
          third-parties, including as required by law or in order to provide the
          services requested. We engage reputable third-party vendors to help us
          manage this Platform, provide content and information, and interact
          better with our customers.
        </p>
        <p className="text-base">
          Although we do not control how third-parties collect or use your
          information to serve interest-based advertising or other targeted
          content, a number of these third-parties may provide you with ways to
          choose not to have your information collected or used in this way.
        </p>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">
          ACCESSING AND CHANGING YOUR INFORMATION
        </h2>
        <p className="text-base">
          You may send us an email at{' '}
          <a
            href="mailto:incidents@futurecitynow.com"
            className="underline decoration-[#7F7F79] underline-offset-4"
          >
            incidents@futurecitynow.com
          </a>
          , to request access to, correct, and/or delete any personal
          information and/or consent to process your PII that you have provided
          to us. We may not accommodate a request to change or delete
          information if we believe the change or deletion would violate any law
          or legal requirement or cause the information to be incorrect.
        </p>

        <h2 className="text-lg font-bold my-4">
          YOUR CALIFORNIA PRIVACY RIGHTS
        </h2>
        <p className="text-base">
          The California Consumer Privacy Act (CCPA) went into effect in 2020
          and was amended by the California Privacy Rights Act (CPRA) on January
          1, 2023. Under CCPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Delete</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Private Right of Action (limited to certain violations only)</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 16)</li>
          <li>Notice/transparency requirements</li>
          <li>Purpose/processing limitation</li>
        </ul>
        <p className="text-base">
          The California Privacy Rights Act (CPRA) went into effect in 2020 and
          was effective on January 1, 2023. Under CPRA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-out of processing sensitive data</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Decide against automated decision-making</li>
          <li>Private Right of Action (limited to certain violations only)</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 16)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">YOUR COLORADO PRIVACY RIGHTS</h2>
        <p className="text-base">
          The Colorado Privacy Act (CPA) went into effect in 2021 and was
          effective July 2023. Under CPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">
          YOUR CONNECTICUT PRIVACY RIGHTS
        </h2>
        <p className="text-base">
          The Connecticut Data Privacy Act (CDPA) went into effect in 2022 and
          was effective July 1, 2023. Under CDPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR DELAWARE PRIVACY RIGHTS (Effective January 2025)
        </h2>
        <p className="text-base">
          The Delaware Personal Data Privacy Act (DPDPA) was enacted in 2023 and
          will be effective on January 1, 2025. Under DPDPA, You have the right
          to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 17)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR INDIANA PRIVACY RIGHTS (Effective January 2026)
        </h2>
        <p className="text-base">
          The Indiana Consumer Data Protection Act (ICDPA) was enacted in 2023
          and will take effect January 2026. Under ICDPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">
          YOUR IOWA PRIVACY RIGHTS (Effective January 2025)
        </h2>
        <p className="text-base">
          The Iowa Consumer Data Protection Act (ICDPA) was enacted in 2023 and
          will take effect on January 2025. Under ICDPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Delete</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Private Right of Action (limited to certain violations only)</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR MONTANA PRIVACY RIGHTS (Effective October 2024)
        </h2>
        <p className="text-base">
          The Montana Consumer Data Privacy Act (MCDPA) was enacted in 2023 and
          will take effect on October 1, 2024. Under MCDPA, You have the right
          to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR NEW JERSEY PRIVACY RIGHTS (Effective January 2025)
        </h2>
        <p className="text-base">
          New Jersey Data Privacy Act (NJDPA) is a comprehensive privacy law
          that was signed into law in 2024 and will be effective on January 15,
          2025. Under NJDPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR OREGON PRIVACY RIGHTS (Effective July 2024)
        </h2>
        <p className="text-base">
          The Oregon Consumer Privacy Act (OCPA) was enacted in 2023 and will
          take effect on July 1, 2024. Under OCPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR TENNESSEE PRIVACY RIGHTS (Effective July 2025)
        </h2>
        <p className="text-base">
          The Tennessee Information Protection Act (TIPA) was enacted in 2023
          and will take effect on July 1, 2025. Under TIPA, You have the right
          to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR TEXAS PRIVACY RIGHTS (Effective July 2024)
        </h2>
        <p className="text-base">
          The Texas Data Privacy and Security Act (TDPSA) was enacted in 2023
          and will take effect on July 1, 2024. Under TDPSA, You have the right
          to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>
      </div>

      <div className="space-y-6">
        <h2 className="text-lg font-bold my-4">YOUR UTAH PRIVACY RIGHTS</h2>
        <p className="text-base">
          The Utah Consumer Privacy Act (UCPA) was enacted in 2022 and took
          effect on December 31, 2023. Under UCPA, You have the right to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13)</li>
          <li>Notice/transparency requirements</li>
          <li>Prohibition on discrimination (exercising rights)</li>
        </ul>

        <h2 className="text-lg font-bold my-4">YOUR VIRGINIA PRIVACY RIGHTS</h2>
        <p className="text-base">
          The Virginia Consumer Data Protection Act (VCDPA) was enacted in 2021
          and took effect on January 1, 2023. Under VCDPA, You have the right
          to:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Access</li>
          <li>Correct</li>
          <li>Delete</li>
          <li>Opt-in for profiling/targeting advertising data processing</li>
          <li>Portability</li>
          <li>Opt-out of sales</li>
          <li>Right to opt in for sensitive data processing</li>
          <li>Decide against automated decision-making</li>
        </ul>
        <p className="text-base">Our Obligations:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>Opt-in default (requirement age of 13 for sensitive data)</li>
          <li>Notice/transparency requirements</li>
          <li>Risk Assessments</li>
          <li>Prohibition on discrimination (exercising rights)</li>
          <li>Purpose/processing limitation</li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          YOUR PRIVACY RESPONSIBILITIES
        </h2>
        <p className="text-base">To help protect your privacy, be sure:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>not to share your user ID or password with anyone else</li>
          <li>to log off our Platform when you are finished</li>
          <li>
            to take customary precautions to guard against &quot;malware&quot;
            (viruses, Trojan horses, bots, etc.) by installing and updating your
            laptop and mobile devices with suitable anti-virus software
          </li>
        </ul>

        <h2 className="text-lg font-bold my-4">
          NOTICE TO USERS IN THE EUROPEAN UNION
        </h2>
        <p className="text-base">
          Currently, our operations and customers are located primarily in the
          United States. This Privacy Policy does not apply to users who are in
          the European Union (EU) or the European Economic Area (EEA), as they
          are subject to different data protection laws and regulations. If you
          are an EU or EEA user, please do not use this Platform or provide any
          personal information to us.
        </p>

        <h2 className="text-lg font-bold my-4">CHILDREN UNDER THE AGE OF 13</h2>
        <p className="text-base">
          Our Services are not directed to, and FCN does not knowingly collect
          or solicit personal information from, children under the age of 13. If
          we learn we have collected or received personal information from a
          child under the age of 13, we will delete that information. If you
          believe we might have any information from or about a child under the
          age of 13, please contact us at{' '}
          <a
            href="mailto:incidents@futurecitynow.com"
            className="underline decoration-[#7F7F79] underline-offset-4"
          >
            incidents@futurecitynow.com
          </a>
          .
        </p>

        <h2 className="text-lg font-bold my-4">CHANGES TO THIS POLICY</h2>
        <p className="text-base">
          We reserve the right to update or change this Privacy Policy at any
          time. If we make a material change to our Privacy Policy, we will
          provide notice by posting on our Platform that our Privacy Policy has
          changed along with the relevant changes.
        </p>
        <p className="text-base">
          In the event we make a material change to how we use your PII, we will
          provide you with an opportunity to opt-out of such new or different
          use. The date this Privacy Policy was last revised is at the top of
          this page. We encourage you to review this Privacy Policy periodically
          to check for any updates or changes.
        </p>

        <h2 className="text-lg font-bold my-4">CONTACT US</h2>
        <p className="text-base">
          If you have questions or comments about this Privacy Policy, use the
          contact form on our Platform, or email us at{' '}
          <a
            href="mailto:incidents@futurecitynow.com"
            className="underline decoration-[#7F7F79] underline-offset-4"
          >
            incidents@futurecitynow.com
          </a>
          .
        </p>
      </div>
    </LegalPageWrapper>
  );
};

export default PrivacyPolicyPage;
